<template>
  <div v-if="user !== null">
    <slot :remove="remove" :is_following="is_following"></slot>
  </div>
</template>
<script>
  export default {
    props: {
      initial_is_following: {},
      user: {},
      other_user_id: {},
    },
    data: v => ({
      is_following: v.initial_is_following,
    }),
    methods: {
      remove() {
        let id = this.other_user_id;
        axios.delete(`/api/v1/follower/${id}`, {
          params: {api_token: this.user.api_token},
        }).then(resp => {
          this.is_following = false
        })
      },
    }
  }
</script>
